import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const button = document.getElementById( 'hamburger' );
const navbar = document.getElementById( 'navBar-wrapper' );

function toggleNav() {
  const isHidden = button.getAttribute( 'aria-expanded' ) === 'false';
  button.setAttribute( 'aria-expanded', isHidden );
  navbar.setAttribute( 'aria-hidden', !isHidden );
  document.documentElement.classList.toggle( 'is-open' );
  if ( isHidden ) {
    disableBodyScroll( navbar );
  } else {
    enableBodyScroll( navbar );
  }
}

function init() {
  button.addEventListener( 'click', toggleNav );
}

export default {
  init,
};
